import React from 'react';
import ServicePage from '../../components/ServicePage';
import { Shield, Search, Globe, Zap, BarChart, Smartphone, ClipboardList, Wrench, Settings, Rocket } from 'lucide-react';

export default function SecurityOps() {
  return (
    <ServicePage
      title="AI 安全运营服务"
      subtitle="大模型赋能 TitanSIEM · MTTD < 15min · 告警降噪率 95%"
      description="卓迈科技安全运营服务（SOC as a Service）基于自研 TitanSIEM 平台，深度融合安全大语言模型（SecLLM）与 Kafka + ES 实时计算引擎。通过 AI 智能研判将海量无效告警压缩 95%，将企业平均威胁发现时间（MTTD）从 24 小时压缩至 15 分钟内，帮中小企业以极低成本获得大厂级智能安全运营能力。"
      icon={<Shield size={40} strokeWidth={1.5} />}
      color="#1a6eff"
      benefits={[
        '大模型智能降噪，过滤 95% 无效告警',
        'MTTD < 15 分钟，写进合同的 SLA 承诺',
        '自研 TitanSIEM 每秒处理百万级事件',
        'AI 自动化溯源与分析报告生成',
        '7×24 值班 + 大模型辅助研判',
      ]}
      features={[
        {
          icon: <Search size={24} />,
          title: '大模型驱动的 TitanSIEM',
          desc: '基于 Kafka + ES 与安全大模型构建的自研分析引擎，支持多源日志采集。传统关联规则结合 AI 语义分析，告警准确率提升 3 倍，MTTD 稳定压在 15 分钟以内。',
          points: ['AI 语义级日志分析', '告警降噪率 95%', 'MTTD < 15min 保障', '每秒百万级事件处理'],
        },
        {
          icon: <Globe size={24} />,
          title: 'AI 威胁情报解析',
          desc: '通过大语言模型深度理解并提取全球非结构化威胁情报（博客、推特、漏洞通告），转化为机读 IOC 接入 TitanSIEM，实现 0day 威胁的毫秒级拦截。',
          points: ['非结构化情报解析', '0day 漏洞提前预警', 'IOC 黑名单毫秒级更新', '误报率 < 5%'],
        },
        {
          icon: <Zap size={24} />,
          title: '智能自动化编排 (AI-SOAR)',
          desc: '大模型驱动的自动化响应体系，AI 自动生成处置建议并转化为 Playbook。将告警分类、隔离封禁等操作全部自动化，响应时间压缩至秒级。',
          points: ['AI 生成处置策略', 'Playbook 自动执行', '恶意 IP 秒级封禁', '人力成本降低 70%'],
        },
        {
          icon: <BarChart size={24} />,
          title: 'AI 资产风险预测',
          desc: '云/物理资产统一纳管，结合大模型对资产暴露面和脆弱性进行动态风险评分预测，直观呈现安全态势大屏，支持等保合规报告一键智能生成。',
          points: ['动态风险评分预测', '全资产自动发现', '等保 2.0 智能生成', '云/物理混合环境支持'],
        },
        {
          icon: <Smartphone size={24} />,
          title: '轻量智能 Agent',
          desc: 'Agent 安装包 < 5MB，内置轻量级 AI 行为基线检测模型。平均 30 分钟完成全企业部署，不影响业务系统性能（CPU 占用 < 1%）。',
          points: ['AI 行为基线检测', 'Agent < 5MB', '30 分钟完成接入', 'CPU 占用 < 1%'],
        },
        {
          icon: <ClipboardList size={24} />,
          title: '大模型报告与复盘',
          desc: '利用大语言模型自动总结当月安全事件，生成人类易读的《安全运营月报》，包含高危资产排行与 AI 修复建议，节省 80% 的人工整理时间。',
          points: ['LLM 自动撰写报告', '事件专项取证分析', 'AI 定制修复建议', '节省 80% 整理时间'],
        },
      ]}
      process={[
        { icon: <ClipboardList size={24} />, title: '现状评估', desc: '梳理资产规模、日志源类型，制定定制化接入方案，明确 SLA 指标' },
        { icon: <Wrench size={24} />, title: '快速接入', desc: '轻量 Agent 部署 + 日志源配置，平均 30 分钟完成接入，不停服' },
        { icon: <Settings size={24} />, title: '规则调优', desc: '基于业务特征和流量基线，调整检测规则，将误报率压至 5% 以内' },
        { icon: <Rocket size={24} />, title: 'SLA 起算', desc: '7×24 值班监控正式启动，MTTD SLA 合同生效，开始计时保障' },
        { icon: <BarChart size={24} />, title: '持续优化', desc: '每月安全复盘 + 规则迭代，威胁模型随业务变化持续更新' },
      ]}
      nextService={{ name: '渗透测试服务', path: '/services/pen-test' }}
    />
  );
}
